import classNames from 'classnames';
import React, { useState } from 'react';

const CasesCard = props => {
  const { cardClass, logoUrl, logoClass, imageUrl, imageClass, increaseNum, increaseText, avgNum, avgText, monthNum, monthText } = props;

  return (
    <div
      className={classNames(
        'w-[190px] md:w-[350px] rounded-[5px] relative bg-[#EAE4EC] flex flex-col items-center justify-center gap-[23px]',
        cardClass
      )}
    >
      <img src={logoUrl} className={logoClass} alt="logo" />
      <div className="flex flex-col justify-center items-center gap-[8px] pb-[50px] text-center">
        <p className=" text-[16px] font-[400] leading-[20px]">
          <span className="font-[700]">{increaseNum}</span> {increaseText}
        </p>
        <p className="text-[16px] font-[400] leading-[20px]">
          <span className="font-[700]">{avgNum}</span> {avgText}
        </p>
        <p>
          <span className="font-[700]">{monthNum}</span> {monthText}
        </p>
      </div>
      <img src={imageUrl} className={classNames('h-[130px] md:h-[190px] absolute right-0', imageClass)} alt="case" />
    </div>
  );
};

export default CasesCard;
